import {
  CrudRoleBase,
  extractCrudRole as extractCrudRoleBase
} from 'common/type/enum';

import * as keycloakRoles from './keycloakRoles';
import * as seletores from './seletores';

export type KeycloakRole = typeof keycloakRoles[keyof typeof keycloakRoles];
export type Seletor = typeof seletores[keyof typeof seletores];

export type CrudRole = CrudRoleBase<KeycloakRole>;

export const extractCrudRole = (role: KeycloakRole | undefined) =>
  extractCrudRoleBase<KeycloakRole, CrudRole>(role);

export { keycloakRoles, seletores };
